// @flow
import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

type Props = {
  classes: Object,
  className: string,
  title: string,
};

const OAuthFacebook = ({ classes, className, title, ...rest }: Props) => (
  <a className={classNames(classes.root, className)} {...rest}>
    <svg
      width={16}
      height={16}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      style={{
        flexShrink: "0",
        marginRight: "6px",
      }}
    >
      <path
        d="M43.57 46A2.43 2.43 0 0 0 46 43.57V4.43A2.43 2.43 0 0 0 43.57 2H4.43A2.43 2.43 0 0 0 2 4.43v39.14A2.43 2.43 0 0 0 4.43 46z"
        fill="#3c5a99"
      />
      <path
        d="M32.36 46V29h5.72l.86-6.64h-6.58v-4.28c0-1.92.53-3.23 3.29-3.23h3.52V8.91A47.58 47.58 0 0 0 34 8.65c-5.07 0-8.54 3.09-8.54 8.77v4.9h-5.69V29h5.73v17z"
        fill="#fff"
      />
    </svg>
    <span>{title}</span>
  </a>
);

const styles = (theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    padding: "18px 8px",
    fontSize: "13px",
    fontWeight: "600",
    textAlign: "center",
    borderRadius: theme.globalBorderRadius,
    textDecoration: "none",
    color: "inherit",
  },
});

export default withStyles(styles)(OAuthFacebook);
